import React from 'react';

class E8LeftMenuTop4Email extends React.Component {
    constructor(props) {
        super(props);
        // type：写信（0），收信（1）
        // dataItems：写信/收信的类型列表
        this.state = {type: 0, visible: false, data: [], dataItems: []}
    }

    componentWillReceiveProps(nextProps) {
        this.setState({data: nextProps.emailMenu});
    }

    render() {
        const {type, visible, data, dataItems} = this.state;
        const writeEmailMenu = data[0] || {};
        const receiveEmailMenu = data[1] || {};
        const currentClassName = type == 0 ? 'e8left-lmt-email-item-ul-bc1' : 'e8left-lmt-email-item-ul-bc2';

        return (
            <div className="e8left-lmt-email">
                <div className="e8left-lmt-email-item" onClick={() => this.onSelect(0, writeEmailMenu, 0)}>
                    <div className="e8left-lmt-email-title">{writeEmailMenu.name}</div>
                    <div className="e8left-lmt-email-dropdown" onClick={(e) => this.onSelectDropdown(e, 0)}></div>
                </div>
                <div className="e8left-lmt-email-item" onClick={() => this.onSelect(1, receiveEmailMenu, 0)}>
                    <div className="e8left-lmt-email-title">{receiveEmailMenu.name}</div>
                    <div className="e8left-lmt-email-dropdown" onClick={(e) => this.onSelectDropdown(e, 1)}></div>
                </div>
                <div className="e8left-lmt-email-clear"></div>
                {
                    visible ? (
                            <ul className={`e8left-lmt-email-item-ul ${currentClassName}`}>
                                {
                                    dataItems.map((item, index) => {
                                        return <li key={index} onClick={() => this.onSelect(index, item, 0)}>{item.name}</li>
                                    })
                                }
                            </ul>
                        ) : ''
                }
            </div>
        );
    }

    onSelectDropdown(e, type) {
        e.stopPropagation();

        const {data} = this.state;
        const writeEmailMenu = data[0] || {};
        const receiveEmailMenu = data[1] || {};

        let dataItems = [];
        if (type == 0) {
            dataItems = writeEmailMenu.child || [];
        } else if (type == 1) {
            dataItems = receiveEmailMenu.child || [];
        }

        this.setState({type: type, visible: type != this.state.type || !this.state.visible, dataItems: dataItems});
    }

    onSelect(key, item, type) {
        this.setState({visible: false});
        this.props.onSelect(key, item, type);
    }
}

export default E8LeftMenuTop4Email;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology8/E8LeftMenuTop4Email.js